<div class="filters-labels-group">
    <fieldset>
        <input type="text" class="labels-search"
            rows="1"
            [placeholder]="placeholder"
            [ngModel]="input"
            (ngModelChange)="input = $event"
            (keydown.enter)="onEnter($event)"
        />
    </fieldset>
    <div class="filter-results">
        <core-labels-list [labels]="labelsFiltered | filterByField: input : 'name'" (choose)="selectLabel($event)"></core-labels-list>
    </div>
</div>
